import { AuthenticationState } from './state'

export const getters = {
    isAuthenticated: (state: AuthenticationState) => !!state.token,
}
